import combinedShotData from './data/combinedShotData.js';
import SHOT_COLOR_GENERATORS from './util/SHOT_COLOR_GENERATORS.js';
import ShotChart from './ShotChart.js';
import Button from '@mui/material/Button';
import { useNavigate, Link } from "react-router-dom";

function Home() {
  const navigate = useNavigate(); 
  const exploreThrees = () => {
    navigate('/shots');
  };

  return (
    <div className="home-page">
      <h1>THE GREATEST SHOOTER OF ALL TIME</h1>
      <p>On December 14, 2021 at Madison Square Garden in New York City, Stephen Curry broke the NBA’s all-time 3-pointer record when he hit his 2974th three-pointer.</p>
      <p>Here you can find information on each of those individual 3-pointers that make up this historic record.</p>
      <ShotChart
        shots={combinedShotData}
        strokeWidth="0.5"
        opacity="0.3"
        shotColorGenerator={SHOT_COLOR_GENERATORS['HOME_OR_AWAY']}
      />

      <p>Which is the best?</p>
      <p>The <Link to='/shots/2974'>record breaker</Link>?</p>
      <p>The 37 ft, <Link to='/shots/1479'>overtime game winner</Link> against OKC?</p>
      <p>This <Link to='/shots/1776'>half court heave</Link> going into halftime?</p>
      <p>This <Link to='/shots/1507'>look-away three</Link> as part of a 4th quarter rally to beat the Suns?</p>
      <p>Explore them all!</p>
      <Button variant="outlined" onClick={exploreThrees}>Find your favorite</Button>
    </div>
  );
}

export default Home;